module.exports = __webpack_public_path__ + "img/growthAbility4.daef8bc9.png";